interface GlobalBannerProps {
  html: string
  color?: string
}

import { sanitizeBannerHtml } from '@/src/lib/sanitize'

export function GlobalBanner({ html, color = '#fef3c7' }: GlobalBannerProps) {
  // Sanitize defensively even though banner HTML is admin-curated:
  // an unsanitized dangerouslySetInnerHTML on a public page would be a
  // stored-XSS sink if an admin account were ever compromised.
  const safeHtml = sanitizeBannerHtml(html)
  return (
    <div
      className="mb-4 p-3 rounded border text-sm prose prose-sm [&>*:first-child]:mt-0 [&>*:last-child]:mb-0"
      style={{
        backgroundColor: color,
        borderColor: `color-mix(in srgb, ${color} 80%, black)`,
      }}
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  )
}
